import { List } from "@mui/material";
import { BookingDocumentItem } from "./bookingDocumentApi";
import ScriptListItem from "./ScriptListItem";

interface ScriptListProps {
  documents: BookingDocumentItem[];
}

export default function ScriptList({ documents }: ScriptListProps) {
  if (documents.length === 0) {
    return null;
  }

  return (
    <List disablePadding>
      {documents.map(doc => (
        <ScriptListItem key={doc.id} item={doc} />
      ))}
    </List>
  );
}
